'use client';

import { Link } from '@/app/(webapp)/_i18n/navigation';
import clsx from 'clsx';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof Link> & {
    isActive?: boolean;
};

export default function NavigationLink({ href, isActive = false, onClick, ...rest }: Props) {
    return (
        <Link
            aria-current={isActive ? 'page' : undefined}
            className={clsx(
                'inline-block px-3 py-3 transition-colors',
                isActive
                    ? 'bg-overlay-white-30 rounded-[8px]'
                    : 'text-content-on-dark hover:text-content-muted duration-300',
            )}
            href={href}
            onClick={onClick}
            {...rest}
        />
    );
}
